






















import Vue from 'vue'

import cToolbar from './toolbar.vue'
import { SingleTrend, MultipleTrend } from '@/components/trending'

import {
  ReadRecord,
  RecordRequest,
  Parameter,
  FindParameter,
  InfluxResult,
} from '@/api/cems'

export default Vue.extend({
  name: 'HistoricalTrendView',
  components: { cToolbar, SingleTrend, MultipleTrend },
  data() {
    return {
      loading: false,
      query: {
        avg: '',
        stackUID: '',
        from: '',
        to: '',
        parameters: [],
        chartStyle: '',
      } as RecordRequest,
      parameters: [] as Parameter[],
      records: {} as InfluxResult,
    }
  },
  methods: {
    async findParameters() {
      this.parameters = await FindParameter(this.query.stackUID)
    },
    getIndexOfParameter(name: string): number {
      const keys = Object.keys(this.parameters)
      return keys.indexOf(name)
    },

    async findRecord() {
      this.records = await ReadRecord(this.query)
    },

    async updateTrend() {
      this.loading = true
      try {
        await this.findRecord()
      } catch {
        //
      }

      this.loading = false
    },

    legendSelected(args: any) {
      console.log(args)
    },
  },

  watch: {
    '$route.query': {
      deep: true,
      handler: function(val: RecordRequest) {
        if (!val.stackUID) {
          return
        }

        if (val.stackUID != this.query.stackUID) {
          this.query = val
          this.findParameters()
        }
        this.query = { ...val }
      },
    },
  },

  created() {
    this.query = JSON.parse(JSON.stringify(this.$route.query))
    if (this.query.stackUID) {
      this.findParameters()
    }
  },
})
